import React from 'react';

/**
 * VolumetricBackground Component
 * 
 * EXACT match to app.html lines 71-86
 * 
 * THREE radial gradients with blur(80px) and opacity 0.6
 * Positioned at: (20%, 20%), (80%, 80%), (50%, 50%)
 * Static (no animation)
 */
const VolumetricBackground = ({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  
  return (
    <>
      {/* Mobile: Simplified single gradient */}
      <div 
        className="md:hidden"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
          background: isDark
            ? 'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(255, 255, 255, 0.06) 0%, transparent 70%)'
            : 'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(0, 0, 0, 0.02) 0%, transparent 70%)',
          filter: 'blur(40px)',
          opacity: isDark ? 0.4 : 0.2,
        }}
      />
      
      {/* Desktop/Tablet: Full three-gradient effect */}
      <div 
        className="hidden md:block"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
          background: isDark
            ? `radial-gradient(ellipse 80% 60% at 20% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
               radial-gradient(ellipse 60% 80% at 80% 80%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
               radial-gradient(ellipse 70% 50% at 50% 50%, rgba(255, 255, 255, 0.08) 0%, transparent 60%)`
            : `radial-gradient(ellipse 80% 60% at 20% 20%, rgba(0, 0, 0, 0.02) 0%, transparent 50%),
               radial-gradient(ellipse 60% 80% at 80% 80%, rgba(0, 0, 0, 0.015) 0%, transparent 50%),
               radial-gradient(ellipse 70% 50% at 50% 50%, rgba(0, 0, 0, 0.01) 0%, transparent 60%)`,
          filter: 'blur(80px)',
          opacity: isDark ? 0.6 : 0.3,
        }}
      />
    </>
  );
};

export default VolumetricBackground;

